import { actionCreatorFactory } from 'typescript-fsa'
import { Control } from '../../types'

const actionCreator = actionCreatorFactory()

export const registerControls = actionCreator<Control[]>('registerControls')
